import { Pipe, PipeTransform } from '@angular/core';
import { TextTranslatableSchema } from '@app/schemas/text';

@Pipe({
  name: 'textTranslate',
})
export class TextTranslatePipe implements PipeTransform {

  public transform(text: TextTranslatableSchema | null | undefined, lang: string | 'fallback'): string {
    if (!text) {
      return '';
    }

    if (lang === 'fallback') {
      return text.translations[text.fallback];
    }

    return text.translations[lang] || text.translations[text.fallback];
  }

}
